var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"app",attrs:{"id":"App"},on:{"click":() => _vm.refreshActiveTime()}},[_c('LoadingShowText',{attrs:{"id":"Loading","isLoading":_vm.isLoadingWithText,"text":_vm.isLoadingText}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }